import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { parse, isValid } from "date-fns"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Safely parse a date value that could be a Date object or a string.
 * Handles localStorage date strings stored in "MM/dd/yyyy" format.
 * @param {Date|string} value - The date value to parse
 * @param {Date} fallback - Fallback date if parsing fails (default: new Date())
 * @returns {Date} A valid Date object
 */
export function safeParseDate(value, fallback = new Date()) {
  // If already a valid Date object, return it
  if (value instanceof Date && isValid(value)) {
    return value;
  }

  // If it's a string, try to parse it
  if (typeof value === 'string' && value.trim() !== '') {
    // Try parsing "MM/dd/yyyy" format first (most common in this app)
    let parsed = parse(value, 'MM/dd/yyyy', new Date());
    if (isValid(parsed)) {
      return parsed;
    }

    // Try parsing "yyyyMMdd" format (used in some dashboard components)
    parsed = parse(value, 'yyyyMMdd', new Date());
    if (isValid(parsed)) {
      return parsed;
    }

    // Try parsing ISO format
    parsed = new Date(value);
    if (isValid(parsed)) {
      return parsed;
    }
  }

  // Return fallback if all parsing fails
  return fallback;
}

